#
#    @author Jaromír Navara [BG] <web@bagricek.cz>
#    26.8.2016 4:14
#
# A class-based template for jQuery plugins in Coffeescript
#
#     $('.target').omalovanky({ paramA: 'not-foo' });
#     $('.target').omalovanky('myMethod', 'Hello, world');
#
# Check out Alan Hogan's original jQuery plugin template:
# https://github.com/alanhogan/Coffeescript-jQuery-Plugin-Template
#
# REQUIRED: jQuery, palette.js, ionSound
#
(($, window) ->

  # Define the plugin class
  class Omalovanky
    $svgWrapper: null
    $palleteEl: null
    $selectedColorEl: null
    #timers
    rtime: null
    timeout: false
    sideColorWidth: 40

    defaults:
      pallete: ["#ffffff","#7f7f7f","#000000","#ffff80","#ffff40","#ffff00","#7f7f00","#ffe680","#ffda40","#ffcd00","#7f6600","#ffcd80","#ffb440","#ff9b00","#7f4d00","#ffb480","#ff8f40","#ff6900","#7f3400","#ff9980","#ff6540","#ff3200","#7f1900","#ff8080","#ff4040","#ff0000","#7f0000","#ff8099","#ff4065","#ff0032","#7f0019","#ff80b4","#ff408f","#ff0069","#7f0034","#ff80cd","#ff40b4","#ff009b","#7f004d","#ff80e6","#ff40da","#ff00cd","#7f0066","#ff80ff","#ff40ff","#ff00ff","#7f007f","#e680ff","#da40ff","#cd00ff","#66007f","#cd80ff","#b440ff","#9b00ff","#4d007f","#b480ff","#8f40ff","#6900ff","#34007f","#9b80ff","#6940ff","#3700ff","#1b007f","#8080ff","#4040ff","#0000ff","#00007f","#809bff","#4069ff","#0037ff","#001b7f","#80b4ff","#408fff","#0069ff","#00347f","#80cdff","#40b4ff","#009bff","#004d7f","#80e6ff","#40daff","#00cdff","#00667f","#80ffff","#40ffff","#00ffff","#007f7f","#80ffe6","#40ffda","#00ffcd","#007f66","#80ffcb","#40ffb0","#00ff96","#007f4b","#80ffb2","#40ff8b","#00ff64","#007f32","#80ff9b","#40ff69","#00ff37","#007f1b","#80ff80","#40ff40","#00ff00","#007f00","#9bff80","#69ff40","#37ff00","#1b7f00","#b4ff80","#8fff40","#69ff00","#347f00","#cdff80","#b4ff40","#9bff00","#4d7f00","#e6ff80","#daff40","#cdff00","#667f00",]
      done: "#omalovanky_done"

    constructor: (el, options) ->
      @options = $.extend({}, @defaults, options)
      @$el = $(el)
      @$svgWrapper = @$el.find("svg");

      @init()

    init: ->
      @$el.height "85%"
      @$el.css "position", "relative"
      @_initSvg()
      @$palleteEl = $('#colorPallete')
      @generateColorPalletePicker()
      $(window).resize @_onResize
      @_onResize()
      finishSelector = @options.done
      $(finishSelector).click @finish

    _getColorsForPalette: (count) ->
      totalColorsCount = @options.pallete.length
      totalRows = Math.ceil (totalColorsCount / 4)
      substractRows = Math.ceil (count / 4)
      pallete = []

      step = Math.round ((totalRows/substractRows)*100)
      max = totalRows*100
      for i in [0...max] by step
        i = (Math.round i/100) * 4
        pallete = pallete.concat (@options.pallete.slice i, i+4)

      pallete

    generateColorPalletePicker: ->
      @_colorPalleteResize()
      @$palleteEl.find("li.omalovanky_arrow").unbind("click").click @rollPallete

      colorsCount = (@_getMaxRows() * 4) - 1
      for colorHex,index in @_getColorsForPalette(colorsCount)
        $color = $("<li></li>").css
         width: @sideColorWidth
         height: @sideColorWidth
         background: colorHex
        $color.data "hex", colorHex
        $color.attr "id", colorHex.slice 1
        @$palleteEl.append $color
      @$palleteEl.find("li:not(.omalovanky_arrow)").unbind("click").click @onPickColor
      @$el.append @$palleteEl

    regenerateColorPalette: ->
      $back = @$palleteEl.find(".omalovanky_arrow")
      @$palleteEl.find("li:not(.omalovanky_arrow)").remove()
      @generateColorPalletePicker()
      if @$selectedColorEl
        @_pickColor @$selectedColorEl.attr "id"
      if !$back.hasClass("bgFlip")
        @_paletteShowOnlyOneColumn()

    _paletteShowOnlyOneColumn: ->
      @$palleteEl.find("li:not(.omalovanky_arrow)").each (i,color)->
        if i > 3
          if((i%4) != 0)
            $(color).hide()

    _getMaxRows: ->
      direction = @$palleteEl.data "direction"
      if direction == "bottom" then sideWrapper = @$el.height() else sideWrapper = @$el.width()
      wrapperSide = parseInt sideWrapper
      @sideColorWidth = 40
      Math.floor(wrapperSide/@sideColorWidth)

    _colorPalleteResize: =>
      @$palleteEl.data "direction", @_getColorPaletteDirection()
      direction = @$palleteEl.data "direction"
      maxColors = @_getMaxRows()
      cssData = {}
      cssData.overflow = "hidden"
      if direction == "bottom"
        cssData.height = maxColors * @sideColorWidth
        cssData.width = @sideColorWidth*4
        cssData.right = "15px"
        cssData.left = "initial"
        cssData.top = 0
        cssData.bottom = "initial"
        @$palleteEl.removeClass "flex"
        @$palleteEl.find(".omalovanky_arrow").removeClass "rotated"
        @$palleteEl.find(".omalovanky_arrow").removeClass "bgFlip270"
      else
        cssData.width = maxColors * @sideColorWidth
        cssData.height = @sideColorWidth*4
        cssData.left = "15px"
        cssData.right = "initial"
        cssData.top = "initial"
        cssData.bottom = 0
        @$palleteEl.addClass "flex"
        @$palleteEl.find(".omalovanky_arrow").addClass "rotated"
        @$palleteEl.find(".omalovanky_arrow").addClass "bgFlip270"

      @$palleteEl = $('#colorPallete').css cssData

    _getColorPaletteDirection: ->
      width = parseInt @$el.width()
      height = parseInt @$el.height()

      if width > height
        return "bottom"
      else
        return "right"

    rollPallete: (e)=>
      $target = $(e.currentTarget)
      animationData = {}
      whatSide = "width"
      if @$palleteEl.data("direction") == "bottom" then whatSide = "width" else whatSide = "height"

      $target.toggleClass "bgFlip"
      if !$target.hasClass "bgFlip"
        animationData[whatSide] = "40px"
        @$palleteEl.stop().velocity(animationData,500, @_resizeAll)
        @_paletteShowOnlyOneColumn()
      else
        animationData[whatSide] = "160px"
        @$palleteEl.stop().velocity(animationData,500, @_resizeAll)
        @$palleteEl.find("li:not(.omalovanky_arrow)").show()

    onPickColor: (e)=>
      $colorElem = $(e.target)
      @_pickColor $colorElem.attr "id"

    _pickColor: (color)=>
      if @$selectedColorEl
        @$selectedColorEl.find(".active").remove()
      $color = $("##{color}")
      if($color.length)
        @$selectedColorEl = $color
        @$selectedColorEl.append '<span class="active"></span>'
      if !ion.muted
        ion.sound.play("sound_click")

    _initSvg: ->
      @$svgWrapper.attr
        "id": "omalovanky-game"
        "width": null
        "height": null

      @$svgWrapper.find("rect, path, polygon").each ->
        $path = $(this)
        if ["#FFFFFF","#FFF","#ffffff","#fff"].indexOf($path.attr("fill")) != -1
         $path.attr "fill", null
         $path.css "fill", "#FFF"
         $path.attr "class", (index, classes) ->
          return (if classes then classes + " " else "") + 'fillable';
      @$svgWrapper.find(".fillable").click @_onPathClicked
      @_resizeAll()

    _onPathClicked: (e) =>
      if !ion.muted
        ion.sound.play("sound_click")
      if @$selectedColorEl != null
        color = @$selectedColorEl.data "hex"
        $(e.target).css "fill", color

    _fitSvg: ->

    _resizeAll: =>
      maxHeight = @$el.height()
      maxWidth = @$el.width()
      # - pallete width
      ###if @$palleteEl
        maxWidth -= @$palleteEl.width()
      else
        maxWidth -= 4 * 40
      ###
      smallerSide = 0
      if maxWidth > maxHeight then smallerSide = maxHeight else smallerSide = maxWidth

      @$svgWrapper.width smallerSide
      @$svgWrapper.height smallerSide

    _onResize: (e = null)=>
      @rtime = new Date()
      if (@timeout == false)
        @timeout = true
        setTimeout(@_onResizeEnd, 200)

    _onResizeEnd: =>
      if (new Date() - @rtime < 200)
        setTimeout(@_onResizeEnd, 200)
      else
        @timeout = false
        @$palleteEl.data "direction", @_getColorPaletteDirection()
        @_resizeAll()
        @regenerateColorPalette()

    finish: (e)=>
      e.preventDefault()
      $svgData = $('<input type="text" name="svg" />').val @$svgWrapper.outerHTML()
      finishSelector = @options.done

      $('#sendOmalovanka')
      .attr("action", $(finishSelector).attr("href"))
      .append($svgData)
      .submit()



  # Define the plugin
  $.fn.extend omalovanky: (option, args...) ->
    @each ->
      $this = $(this)
      data = $this.data('omalovanky')

      if !data
        $this.data 'omalovanky', (data = new Omalovanky(this, option))
      if typeof option == 'string'
        data[option].apply(data, args)

) window.jQuery, window